export const NOTIFICATION_LOADING = "NOTIFICATION_LOADING";
export const GET_NOTIFICATION = "GET_NOTIFICATION";
export const MAKE_NOTIFICATION_SEEN = "MAKE_NOTIFICATION_SEEN";
export const REMOVE_NOTIFICATIOn = "REMOVE_NOTIFICATION";
